import Menu from "./Menu"
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Styles from '../../styles/Faq.module.css'
import Divider from '@mui/material/Divider';

export default function Faq() {
    return (
        <>
            <Menu />
            <div className={Styles.container}>

                <Typography variant="h3" textAlign='center'>Preguntas frecuentes</Typography>

                <div className={Styles.questions}>
                    <Typography variant="h5" >Version PRO</Typography>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            id="panel1a-header"
                        >
                            <Typography>Como puedo conseguir la versión PRO de Tookeat?</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                                ¡Haz crecer tu negocio al siguiente nivel con la versión PRO de TooKeat! Desbloquea todas las funciones disponibles para impulsar tu éxito empresarial al contratar
                                nuestro plan PRO. Dirígete a la sección 'Planes Pagos' para obtener información detallada y descubrir cómo nuestras herramientas pueden potenciar tu negocio.
                                La suscripción se realiza de forma sencilla y segura a través de MercadoPago
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            id="panel2a-header"
                        >
                            <Typography>Como funciona la prueba gratis de la versión PRO?</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                                Crea una cuenta de manera rápida y totalmente gratuita, y accede a una amplia selección de funciones de TooKeat para potenciar tu negocio
                                (ten en cuenta que no todas las funciones están disponibles en la versión de prueba gratuita). Además, podrás realizar ventas en línea y publicar hasta 10 productos.
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            id="panel3a-header"
                        >
                            <Typography>Como puedo cancelar mi suscripción a la versión PRO?</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                                Si deseas cancelar tu suscripción a la versión PRO de TooKeat, simplemente ingresa a tu cuenta de MercadoPago y dirígete a la sección de suscripciones.
                                Una vez allí, encontrarás la opción para cancelar tu suscripción mensual. Ten en cuenta que si cancelas dentro de los primeros 15 días de la prueba gratuita, no se te cobrará ningún cargo.
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            id="panel4a-header"
                        >
                            <Typography>Que dia se cobrará mi suscripción a la versión PRO de Tookeat?</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                                El día en el que se te cobrará por tu suscripción al plan de TooKeat dependerá de la frecuencia de pago que hayas seleccionado.
                                En el caso de la frecuencia mensual, se realizará el primer cobro después de la activación de la suscripción y luego se te cobrará cada 30 días a partir de esa fecha.
                                Para los planes anuales, el primer cobro se realizará al activar la suscripción y, posteriormente, se te cobrará cada 365 días.
                            </Typography>
                        </AccordionDetails>
                    </Accordion>

                    <Divider sx={{ m: 2 }} />

                    <Typography variant="h5" >Productos</Typography>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            id="panel5a-header"
                        >
                            <Typography>Como agregar un producto?</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                                Debes ir a la sección "Productos" en el menú y luego tocar el botón "Crear un nuevo producto".
                                A cada producto debes elegirle un nombre y una categoria de forma obligatoria, tambien puedes destacarlo, asignarle un precio e indicar sus calorias aproximadas.
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            id="panel6a-header"
                        >
                            <Typography>Que son las versiones o extras?</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                                Cada producto que crees puede tener varias versiones o extras. Por ejemplo puedes crear una versión que sea "bebida" y que el cliente elija una opción para acompañar su pedido.
                                Otro caso de uso es el ofrecer "extras", por ejemplo que tu cliente pueda agregar unidades de carne extra con su hamburguesa.
                            </Typography>
                        </AccordionDetails>
                    </Accordion>

                    <Divider sx={{ m: 2 }} />

                    <Typography variant="h5" >Personalización</Typography>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            id="panel7a-header"
                        >
                            <Typography>Que puedo personalizar de mi menu online?</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                                Puedes elegir un color que se va a utilizar en algunos aspectos del menú, también puedes elegir un logo y una imagen de portada para tu menú.
                            </Typography>
                        </AccordionDetails>
                    </Accordion>

                    <Divider sx={{ m: 2 }} />

                    <Typography variant="h5" >Administrar tu negocio</Typography>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            id="panel8a-header"
                        >
                            <Typography>Que es el identificador de comercio?</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                                Es un identificador unico por comercio, ese mismo va a decidir como va a ser el link a tu menú. Recuerda que siempre que lo cambies todos tus links a tu menú van a ser diferentes y deberás actualizarlos.
                                Por ejemplo si tienes tu link en tu pagina de instagram deberás actualizarlo ahí.
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                </div>
            </div>
        </>
    )
}